export const staffsType = {
  FETCHING: "FETCHING",
  SET_STAFFS: "SET_STAFFS",
  ADD_STAFF: "ADD_STAFF",
  DELETE_STAFF: "DELETE_SATFF",
};
